import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {route} from "preact-router";

import User from "../../../../services/user";
import {openPopup} from "../../utils/popups";

import Casino from "../../../../services/casino-feed";
import Observer from "../../utils/observer";
import { HomeIcon } from "../../utils/icons";
import AwrabetMainMenu from '../../../awrabet/desktop-components/site/main-menu.jsx';

export default class MainMenu extends AwrabetMainMenu {
    render() {
        const currentPath = window.location.pathname;

        return <nav id="main-menu" class="min-w-0 overflow-hidden">
            <ul class="list-none h-full flex">
                <MainMenuButton active={currentPath === '/'}>
                    <Link class="px-0" href="/" onClick={e => {e.preventDefault(); route(e.target.href);}}>
                        <HomeIcon class="h-4 fill-current relative bottom-0.5" />
                    </Link>
				</MainMenuButton>
                <MainMenuButton active={currentPath.startsWith('/prematch')}>
                    <Link href="/prematch/" onClick={e => {e.preventDefault(); route(e.target.href);}}>
                        <Trans>All Sports</Trans>
					</Link>
				</MainMenuButton>
                <MainMenuButton active={currentPath.startsWith('/live')}>
                    <Link href="/live/" onClick={e => {e.preventDefault(); route(e.target.href);}}>
                        <Trans>Live</Trans>
					</Link>
				</MainMenuButton>
                <MainMenuButton active={currentPath.startsWith('/virtual')}>
                    <Link href="/virtual" onClick={e => {e.preventDefault(); route(e.target.href);}}>
                        <Trans>Virtual</Trans>
					</Link>
				</MainMenuButton>
                <MainMenuButton active={currentPath.startsWith('/special-games')}>
                    <Link href="/special-games" onClick={e => {e.preventDefault(); route(e.target.href);}}>
                        <Trans>Special Games</Trans>
					</Link>
				</MainMenuButton>
                <MainMenuButton active={false}>
                    <Link href="javascript:void(0);" onClick={e => {
							e.preventDefault();
							if (User.isLogged()) {
								openPopup(Casino.getPlayUrl('TimelessTech', 'aviator', '15000'));
							} else {
								Observer.notify('open-user-signup');
							}
						}}>
                        <Trans>Aviator</Trans>
					</Link>
				</MainMenuButton>
                <MainMenuButton active={false}>
                    <Link href="javascript:void(0);" onClick={e => {
							e.preventDefault();
							if (User.isLogged()) {
								openPopup(Casino.getPlayUrl('Aviator', 'aviator', 'multi-hot-5'));
							} else {
								Observer.notify('open-user-signup');
							}
						}}>
                        <Trans>Multi Hot 5</Trans>
					</Link>
				</MainMenuButton>
                <MainMenuButton active={currentPath.startsWith('/poker')}>
                    <Link href="/poker" onClick={e => {e.preventDefault(); route(e.target.href);}}>
                        <Trans>Poker</Trans>
                        <NewBadge 	active={currentPath.startsWith('/poker')}/>
					</Link>
				</MainMenuButton>
                <MainMenuButton active={currentPath.startsWith('/slot-tournaments')}>
                    <Link href="/slot-tournaments" onClick={e => {e.preventDefault(); route(e.target.href);}}>
                        <Trans>Race</Trans>
                        <NewBadge active={currentPath.startsWith('/slot-tournaments')} />
					</Link>
				</MainMenuButton>
                <MainMenuButton active={currentPath.startsWith('/promo')}>
                    <Link href="/promo" onClick={e => {e.preventDefault(); route(e.target.href);}}>
                        <Trans>Promo</Trans>
					</Link>
				</MainMenuButton>
            </ul>
        </nav>;
    }
}

export function MainMenuButton({children, active}) {
	if (active)
		return <li class="bg-custom-orange text-harif-950">{children}</li>
	return <li class="hover:bg-custom-orange hover:text-harif-950">{children}</li>
}

export function Link({children, ...props}) {
	return <a {...props} class={"relative h-full w-full flex items-center py-2 px-4 uppercase font-bold text-sm "+props['class']}>{children}</a>
}
export const NewBadge = ({active}) => {
	return (
	  <span class={
		"absolute top-2 right-2 transform translate-x-1/2 -translate-y-1/2 text-xxs font-semibold px-1.5 py-0.5 rounded-full animate-pulse " +
		(active ? "text-white" : "text-custom-orange")
	  }>
		NEW
	  </span>
	);
  };